import * as yup from "yup";

export const vacancySchema = yup.object().shape({
  segmento: yup.string().required("Campo obrigatório"),
  segmento_description: yup.string().required("Campo obrigatório"),
  type: yup.string().required("Campo obrigatório"),
  icon: yup.string().required("Campo obrigatório"),
  url_amigavel: yup.string().required("Campo obrigatório"),
});
